import { Record, Map, List } from 'immutable';
import { getKeyframes } from 'Selectors';
import { COMPONENTS, FONTS, SETTINGS } from 'Reducers/ad/utils';

export const GROUP_TYPE = 'group';

export default class ComponentRecord extends Record({
  currentStyle: Map(),
  key: '',
  keyframes: new List(),
  subComponents: new List(),
  settings: new Map({ hidden: false, locked: false, assetIds: new List([]), upload_id: null }),
  actions: new Map(),
  uid: '',
  type: '',
  loop: 1,
  selected: false,
  hovered: false,
  active: false,
}) {
  isGroup() {
    return this.type === GROUP_TYPE;
  }

  isSelected() {
    return this.selected;
  }

  isActive() {
    return this.active;
  }

  isActiveGroup() {
    return this.isGroup() && this.isActive();
  }

  containsComponent(component) {
    return this.subComponents.includes(component.key);
  }

  toList(state) {
    // warning: the state is the ad state, not overall redux state
    const componentFromState = state.getIn([COMPONENTS, this.key]);
    const subComponents = componentFromState.subComponents;

    return new List([componentFromState]).concat(
      subComponents
        .map(c => state.getIn([COMPONENTS, c]).toList(state))
        .flatten(true),
    );
  }

  getKeyframes(state) {
    const keyframeIds = this.keyframes;
    const keyframes = getKeyframes(state);
    return keyframes.filter((k, id) => keyframeIds.includes(id));
  }

  getFontWeightId() {
    return this.getIn([SETTINGS, 'WFPWeightId']);
  }
  getFont(state) {
    const fontWeightId = this.getFontWeightId();
    return state.getIn([FONTS, 'activeFonts']).find(font => font.id === fontWeightId);
  }
  parents(ad) {
    const componentFromState = ad.getIn([COMPONENTS, this.key]);
    const components = ad.get(COMPONENTS);
    const immediateParent = components.find(c => c.containsComponent(componentFromState));

    if (typeof immediateParent === 'undefined') {
      return new List();
    }

    return new List([immediateParent]).concat(
      immediateParent.parents(ad),
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/records/ComponentRecord.js